import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 * *No Image gray box
 */

interface IProps {
  color?: string;
  height?: string;
  width?: string;
}
const NoImage = ({ color, height, width }: IProps) => {
  return (
    <Container color={color} height={height} width={width}>
      <p>No Image</p>
    </Container>
  );
};

export default NoImage;
const Container = styled.div`
  margin: 0 auto;
  background-color: ${(props) =>
    props.color ? props.color : theme.colors.gray_1};
  border-radius: 0.5rem;
  width: ${(props) => (props.width ? props.width : '100%')};
  /* height: 5rem; */
  height: ${(props) => (props.height ? props.height : '5rem')};
  text-align: center;
  position: relative;
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    color: #bfbfbf;
    line-height: 1rem;
  }
`;
